// src/components/Footer.jsx
const Footer = () => (
  <footer className="footer">
    © {new Date().getFullYear()} Control de Productos. Todos los derechos reservados.
  </footer>
);

export default Footer;
